/**
 * @file IconSend Icon
 * @author Auto Generated by @polyv/icons-cli
 */

import { IconBuilder } from '@polyv/icons-vue/icon-builder';

export default IconBuilder(
  'icon-send',
  (data) => `
<svg width="${data.size}" height="${data.size}" viewBox="0 0 48 48">
  <g
    fill="none"
    fill-rule="evenodd"
    stroke="none"
    stroke-width="${data.strokeWidth * 0.5}"
  >
    <rect width="48" height="48" x="0" y="0" />
    <g
      fill="${data.colorDesc[0]}"
      fill-rule="nonzero"
      transform="translate(7.039938,9.038358)"
    >
      <g>
        <path
          d="M31.92075.97371 31.90488 1.1317 27.0925 27.86774C26.984 28.47049 26.35557 28.80522 25.80798 28.59598L25.66109 28.52522 15.81175 22.73385C15.35471 22.46511 15.20207 21.87675 15.4708 21.41971 15.70968 21.01345 16.2011 20.8477 16.62835 21.00463L16.78494 21.07876 25.44606 26.17164 29.436 4.006 12.76606 20.44964 12.76801 28.96164C12.76801 29.43292 12.42841 29.82489 11.98057 29.90617L11.80801 29.92164C11.33672 29.92164 10.94476 29.58204 10.86347 29.1342L10.84801 28.96164 10.848 20.59.46665 14.37071C-.15634 13.99743-.14342 13.11665.43291 12.74396L.58868 12.66196 30.58868.07639C31.24051-.19707 31.93296.30127 31.92075.97371ZM27.088 3.624 3.07806 13.69764 11.662 18.84 27.088 3.624Z"
        />
      </g>
    </g>
  </g>
</svg>
`
);
